/**
 * 银行账号类型
 */
export enum BankType {
  /**
   * 个人账号
   */
  PERSON = 0,

  /**
   * 企业帐号
   */
  ENTERPRISE = 1
}

export const BankTypeTextMap: Record<BankType, string> = {
  [BankType.PERSON]: '个人账号',
  [BankType.ENTERPRISE]: '企业账号'
}
